
import React from 'react';
import { NewsSection } from '../components/NewsSection';

export const News: React.FC = () => {
  return (
    <div className="pt-24 pb-16 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <span className="text-giz-primary font-black uppercase tracking-[.3em] text-xs">Latest Updates</span>
          <h1 className="text-4xl md:text-6xl font-black text-slate-900 mt-4 tracking-tighter">Berita & Acara</h1>
          <p className="text-slate-500 mt-6 max-w-2xl mx-auto text-lg leading-relaxed">
            Ikuti perkembangan terbaru, promo spesial, dan event edukatif di GIZ Park & RIW Surabaya.
          </p>
        </div>
      </div>
      <NewsSection />
    </div>
  );
};
